import { NavElement } from "type/navigation/main_navigation.type";
import { NAV_ELEMENTS } from "constant/navigation";

export function topicWorkCharacterListNav(topicWorkName: string): NavElement {
  return { ...NAV_ELEMENTS.CHARACTER_LIST, title: topicWorkName };
}
